import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap/dist/js/bootstrap.bundle'
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import 'vue3-openlayers/dist/vue3-openlayers.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import 'vue-rate/dist/vue-rate.css'
import "v3-tour/dist/vue-tour.css";
import '@globalhive/vuejs-tour/dist/style.css';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import "vue-multiselect/dist/vue-multiselect.css"
import 'vue3-tour/dist/vue3-tour.css'

import VueFeather from "vue-feather";

import VueApexCharts from "vue3-apexcharts";
import Breadcrumbs from '@/layout/theBreadcrumbs.vue';
import breadCrumbs from "@/layout/breadCrumbs.vue"
import OpenLayersMap from 'vue3-openlayers'
import Datepicker from '@vuepic/vue-datepicker';
import AosVue from "aos-vue";
import Lightbox from 'vue-easy-lightbox'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import { VueMasonryPlugin } from 'vue-masonry';
import rate from 'vue-rate'
import VueTour from 'v3-tour'
import VueJsTour from '@globalhive/vuejs-tour';
import SimpleTypeahead from 'vue3-simple-typeahead';
import vueChartist from "vue-chartist"
import VueNumber from "vue-number-animation";
import Multiselect from 'vue-multiselect'
import { quillEditor } from "vue3-quill";
import Vue3Tour from 'vue3-tour'

import English from "@/core/locales/en.json"
import Russian from "@/core/locales/ru.json"
import Arabic from "@/core/locales/ar.json"
import German from "@/core/locales/ge.json"
import لعربية from "@/core/locales/ae.json"
import 简体中文 from "@/core/locales/cn.json"
import Português from "@/core/locales/pt.json"
import Français from "@/core/locales/fr.json"
import Deutsch from "@/core/locales/de.json"
import Español from "@/core/locales/es.json"

import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    legacy: false,
    locale: '',
    messages: {
        English: English,
        German: German,
        Russian: Russian,
        Arabic: Arabic,
        Español: Español,
        Deutsch: Deutsch,
        Français: Français,
        Português: Português,
        简体中文: 简体中文,
        لعربية: لعربية,
    }
})
createApp(App)
    .use(router)
    .use(createPinia())
    .use(VueApexCharts)
    .use(OpenLayersMap)
    .use(AosVue)
    .use(VueMasonryPlugin)
    .use(Lightbox)
    .use(rate)
    .use(VueTour)
    .use(VueNumber)
    .use(PerfectScrollbar)
    .use(VueJsTour)
    .use(SimpleTypeahead)
    .use(vueChartist)
    .use(quillEditor)
    .use(i18n)
    .use(Vue3Tour)
    .component(VueFeather.name, VueFeather)
    .component('Breadcrumbs', Breadcrumbs)
    .component('breadCrumbs', breadCrumbs)
    .component('Datepicker', Datepicker)
    .component('multiselect', Multiselect)
    .mount('#app')

